import { Button, Expandable } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import type { PropsWithChildren } from "react";
import { useState } from "react";

type Props = PropsWithChildren<{
    className?: string;
    itemsCount: number;
    limit: number;
}>;

const ExpandableList = ({ itemsCount, limit, className, children }: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleExpandClick = (): void => {
        setIsExpanded(!isExpanded);
    };

    const isExpandButtonVisible = itemsCount > limit;

    const expandButtonText = isExpanded
        ? translate("universal.button.showless")
        : translate("universal.button.show-more.count", {
              count: itemsCount - limit,
          });

    return (
        <div className={className}>
            <Expandable
                isExpanded={isExpanded}
                limit={limit}
            >
                {children}
            </Expandable>

            {isExpandButtonVisible ? (
                <Button
                    type="flat"
                    onClick={handleExpandClick}
                >
                    {expandButtonText}
                </Button>
            ) : null}
        </div>
    );
};

export default ExpandableList;
